import React from 'react';
import './MiniButton.css';

export function MiniButton({onClick, type, children, ariaLabel}) {
   const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
         e.preventDefault();
         onClick();
      }
   };

   const buttonClass = type === "delete" 
      ? "mini-button mini-button-delete" 
      : "mini-button mini-button-add";
   
   const defaultAriaLabel = type === "delete" 
      ? "Delete" 
      : "Add";

   return (
      <button
         onClick={onClick}
         onKeyDown={handleKeyDown}
         className={buttonClass}
         aria-label={ariaLabel || defaultAriaLabel}
         type="button"
      >
         {children}
      </button>
   );
}
